import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaQuoteLeft } from 'react-icons/fa';

const Testimonial = () => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
    });
  }, []);

  const testimonials = [
    {
      name: "Krishna Kumar",
      title: "Digital Marketing Strategist",
      image: "https://photosnow.org/wp-content/uploads/2023/12/no-dp32.jpg",
      quote: "Octalbees completely transformed our online presence. Their SEO strategies are top-notch, and we've seen a significant increase in organic traffic. Highly recommend their expertise!"
    },
    {
      name: "Arjun Singh",
      title: "Startup Founder",
      image: "https://photosnow.org/wp-content/uploads/2023/12/no-dp32.jpg",
      quote: "Working with Octalbees was a game-changer for our startup. Their agile development process and dedication to understanding our vision resulted in a truly exceptional product. Fantastic team!"
    },
    {
      name: "Abhishek Mahapatra",
      title: "E-commerce Business Owner",
      image: "https://photosnow.org/wp-content/uploads/2023/12/no-dp32.jpg",
      quote: "The website design Octalbees delivered is not just beautiful, it's also incredibly user-friendly and converts brilliantly. Our sales have seen a noticeable uplift since the launch. Couldn't be happier!"
    }
  ];

  return (
    <>
      <section id="testimonials" className="testimonials-section">
        <div className="container" data-aos="fade-up">
          <h2 className="section-heading">What Our Clients Say</h2>

          <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              {testimonials.map((testimonial, index) => (
                <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                  <div className="testimonial-card">
                    <div className="row align-items-center">
                      <div className="col-lg-8">
                        <div className="quote-content">
                          <FaQuoteLeft className="quote-icon" />
                          <p className="quote-text">{testimonial.quote}</p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="author-profile">
                          <img src={testimonial.image} className="author-image" alt={testimonial.name} />
                          <h5 className="author-name">{testimonial.name}</h5>
                          <span className="author-title">{testimonial.title}</span>
                          <div className="ratings">
                            {[...Array(5)].map((_, i) => (
                              <img key={i} src="Images/star-fill.svg" alt="Star Rating" />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Custom Carousel Controls */}
            <div className="carousel-controls">
              <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <style>{`
                /* =============================================
                   INNOVATIVE TESTIMONIALS SECTION
                   ============================================= */

                .testimonials-section {
                    padding: 100px 0;
                    background-color: #0c001f;
                    color: #fff;
                }

                .testimonials-section .section-heading {
                    font-size: 3.2rem;
                    font-weight: 800;
                    text-align: center;
                    margin-bottom: 4rem;
                    color: #f0f0f0;
                }

                .testimonial-card {
                    background: rgba(26, 15, 45, 0.6);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 24px;
                    padding: 40px 50px;
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                }
                
                .quote-content {
                    position: relative;
                    padding-left: 60px;
                }

                .quote-icon {
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    font-size: 4rem;
                    color: rgba(160, 79, 244, 0.3);
                }

                .quote-text {
                    font-size: 1.5rem;
                    font-style: italic;
                    line-height: 1.6;
                    color: #e0e0e0;
                    font-weight: 300;
                }
                
                .author-profile {
                    text-align: center;
                    padding-left: 20px;
                    border-left: 1px solid rgba(255, 255, 255, 0.1);
                }
                
                .author-image {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin-bottom: 1.5rem;
                    border: 3px solid rgba(160, 79, 244, 0.5);
                }

                .author-name {
                    font-size: 1.4rem;
                    font-weight: 600;
                    color: #fff;
                    margin-bottom: 0.25rem;
                }
                
                .author-title {
                    font-size: 1rem;
                    color: #c0c0c0;
                }

                .ratings {
                    margin-top: 1rem;
                }
                .ratings img {
                    width: 22px;
                    height: 22px;
                    margin: 0 2px;
                }

                /* --- Custom Carousel Controls --- */
                .carousel-controls {
                    display: flex;
                    justify-content: center;
                    gap: 15px;
                    margin-top: 2.5rem;
                }
                .carousel-control-prev,
                .carousel-control-next {
                    position: static;
                    height: 50px;
                    width: 50px;
                    background-color: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 50%;
                    opacity: 0.8;
                    transition: all 0.3s ease;
                }
                .carousel-control-prev:hover,
                .carousel-control-next:hover {
                    background-color: rgba(160, 79, 244, 0.3);
                    opacity: 1;
                }

                /*
                 * THE FIX IS HERE:
                 * These rules override Bootstrap's default dark SVG icons with
                 * light-colored ones that are visible on our dark background.
                */
                .carousel-control-prev-icon {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
                }
                .carousel-control-next-icon {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                }
                
                /* --- Responsive Design --- */
                @media (max-width: 991px) {
                    .author-profile {
                        border-left: none;
                        padding-left: 0;
                        margin-top: 2rem;
                        padding-top: 2rem;
                        border-top: 1px solid rgba(255, 255, 255, 0.1);
                    }
                    .testimonial-card {
                        padding: 30px;
                    }
                    .quote-text {
                        font-size: 1.2rem;
                    }
                }
                
                @media (max-width: 767px) {
                    .testimonials-section { padding: 80px 0; }
                    .testimonials-section .section-heading { font-size: 2.5rem; }
                    .quote-content { padding-left: 0; text-align: center; }
                    .quote-icon { position: static; display: block; margin: 0 auto 1.5rem auto; }
                }

            `}</style>
    </>
  );
};

export default Testimonial;